import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }
const _hoisted_2 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-sm text-error"
}
const _hoisted_5 = { class: "relative items-center py-4" }
const _hoisted_6 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_7 = { class: "flex items-center justify-center" }
const _hoisted_8 = { class: "flex justify-center align-middle" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_get_parent_device = _resolveComponent("get-parent-device")!
  const _component_json_editor_vue = _resolveComponent("json-editor-vue")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isCreateModalOpened,
    "no-padding": true,
    title: _ctx.$t('Devices.CreateTitle'),
    onToggleModal: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createVNode(_component_input_field, {
                  modelValue: _ctx.formData.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                  label: _ctx.$t('Devices.Name'),
                  errorMessage: _ctx.v$?.formData['name']?.$errors[0]?.$message,
                  isError: _ctx.v$?.formData['name']?.$error,
                  required: true
                }, null, 8, ["modelValue", "label", "errorMessage", "isError"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.formData.imei,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.imei) = $event)),
                  label: _ctx.$t('Devices.Imei'),
                  errorMessage: _ctx.v$?.formData['imei']?.$errors[0]?.$message,
                  isError: _ctx.v$?.formData['imei']?.$error
                }, null, 8, ["modelValue", "label", "errorMessage", "isError"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.formData.mac,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.mac) = $event)),
                  label: _ctx.$t('Devices.Mac'),
                  errorMessage: _ctx.v$?.formData['mac']?.$errors[0]?.$message,
                  isError: _ctx.v$?.formData['mac']?.$error
                }, null, 8, ["modelValue", "label", "errorMessage", "isError"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.formData.imsi,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.imsi) = $event)),
                  label: _ctx.$t('Devices.Imsi'),
                  errorMessage: _ctx.v$?.formData['imsi']?.$errors[0]?.$message,
                  isError: _ctx.v$?.formData['imsi']?.$error
                }, null, 8, ["modelValue", "label", "errorMessage", "isError"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.formData.externalId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.externalId) = $event)),
                  label: _ctx.$t('Devices.ExternalId')
                }, null, 8, ["modelValue", "label"]),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("label", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Devices.DeviceTypeId")), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-orange-600 pl-0.5" }, "*", -1))
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.formData.deviceTypeId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.deviceTypeId) = $event)),
                          class: _normalizeClass(`mt-1 w-full ${
                  _ctx.v$?.formData['deviceTypeId']?.$error && 'error'
                }`),
                          options: _ctx.deviceTypes,
                          reduce: (deviceType) => deviceType.id,
                          label: "name"
                        }, null, 8, ["modelValue", "class", "options", "reduce"]))
                  ]),
                  (_ctx.v$?.formData['deviceTypeId']?.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.v$?.formData["deviceTypeId"]?.$errors[0]?.$message), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("Devices.CompanyId")), 1),
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.formData.companyId,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.companyId) = $event)),
                      options: _ctx.companies.items,
                      reduce: (company) => company.id,
                      class: _normalizeClass(`mt-1 w-full`),
                      label: "name"
                    }, _createSlots({ _: 2 }, [
                      (_ctx.hasNextPage)
                        ? {
                            name: "list-footer",
                            fn: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", {
                                  class: "mt-1 cursor-pointer bg-primary px-3 py-1 text-white transition duration-300 hover:bg-primaryhover disabled:cursor-not-allowed",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.loadMoreCompanies && _ctx.loadMoreCompanies(...args)))
                                }, " Load more... ")
                              ])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options", "reduce"])
                  ])
                ]),
                _createVNode(_component_get_parent_device, { onParentDeviceId: _ctx.handleParentDeviceId }, null, 8, ["onParentDeviceId"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("Devices.Data")), 1),
                  _createVNode(_component_json_editor_vue, {
                    modelValue: _ctx.formData.data,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.data) = $event)),
                    "main-menu-bar": false,
                    "status-bar": false,
                    class: _normalizeClass(`mt-1 ${_ctx.v$?.formData['data']?.$error && 'error'}`),
                    mode: "text"
                  }, null, 8, ["modelValue", "class"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-displayed", "title"]))
}